import { TopNavigation } from '../component/nav/top-navigation'
import { Spinner } from '../component/util/spinner/spinner'
import { SessionContext, SessionContextProvider } from '../context/session-context'
import { Router } from '../screen/router'
import { logger } from '../util/logger'
import { WebApp } from './web-app'
import React, { useContext, useEffect, useState } from 'react'
import './index.scss'
import { ToastContainer } from 'react-toastify'

export const App = (): React.ReactElement => {
  const { isLoading: sessionIsLoading } = useContext(SessionContext)
  const [webApp] = useState(new WebApp())

  useEffect(() => {
    webApp.initiate().catch((err) => logger.error(err))
  }, [webApp])

  return (
    <div className="App">
      {sessionIsLoading ? (
        <Spinner />
      ) : (
        <>
          <TopNavigation />
          <Router />
        </>
      )}
      <ToastContainer />
    </div>
  )
}

export const AppWrapper = (): React.ReactElement => (
  <SessionContextProvider>
    <App />
  </SessionContextProvider>
)
